export const sociologyConst = {
  path: "/single-programs/sociology",
  title: "ФАКУЛЬТЕТ СОЦИАЛЬНЫХ НАУК – СОЦИОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Социология — понимание мира через призму общества</h2>
      <p>
        Социология исследует, как устроено общество, какие процессы в нём происходят и как они влияют на повседневную жизнь. Студенты
        изучают поведение социальных групп, динамику ценностей, неравенство, культуру, медиа, технологии и политику.
      </p>
      <p>Программа делает акцент на аналитике, эмпирических исследованиях, работе с данными и критическом мышлении.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Теория и история социологии</li>
        <li>Методы социологических исследований (качественные и количественные)</li>
        <li>Статистика и анализ больших данных (Big Data)</li>
        <li>Социальная психология и поведение масс</li>
        <li>Социальные институты и классовая структура</li>
        <li>Миграция, урбанистика и социология культуры</li>
        <li>Цифровые медиа и общественное мнение</li>
        <li>Управление социальными проектами и оценка воздействия</li>
      </ul>
      <p>
        Программа включает участие в социологических исследованиях, проектной деятельности, сотрудничество с НКО, государственными и
        частными структурами.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Социолог-исследователь</li>
        <li>Аналитик социальных и общественных процессов</li>
        <li>Специалист по социальным проектам и коммуникациям</li>
        <li>Эксперт в сфере миграции, образования, здравоохранения</li>
        <li>Консультант по общественным инициативам</li>
        <li>Data-аналитик в медиа, бизнесе или политике</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€40,000 до €75,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, открывающий путь в науку и практику</li>
        <li>Гибкая форма обучения: дистанционно или очно</li>
        <li>Обучение на русском или английском языке</li>
        <li>Современные методы анализа и цифровые платформы</li>
        <li>Преподаватели — действующие социологи и аналитики</li>
        <li>Поддержка приемной комиссии и помощь с научными стажировками</li>
      </ul>
      <p>Социология — это навигатор в сложном обществе. Мы учим читать карту.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать программу, подготовить документы и успешно пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Социология — понимание мира через призму общества
    Социология исследует, как устроено общество, какие процессы в нём происходят и как они влияют на повседневную жизнь. Студенты изучают поведение социальных групп, динамику ценностей, неравенство, культуру, медиа, технологии и политику.
    Программа делает акцент на аналитике, эмпирических исследованиях, работе с данными и критическом мышлении.
    Что вы будете изучать?
    • Теория и история социологии
    • Методы социологических исследований (качественные и количественные)
    • Статистика и анализ больших данных (Big Data)
    • Социальная психология и поведение масс
    • Социальные институты и классовая структура
    • Миграция, урбанистика и социология культуры
    • Цифровые медиа и общественное мнение
    • Управление социальными проектами и оценка воздействия
    Программа включает участие в социологических исследованиях, проектной деятельности, сотрудничество с НКО, государственными и частными структурами.
    Кем можно работать после окончания?
    • Социолог-исследователь
    • Аналитик социальных и общественных процессов
    • Специалист по социальным проектам и коммуникациям
    • Эксперт в сфере миграции, образования, здравоохранения
    • Консультант по общественным инициативам
    • Data-аналитик в медиа, бизнесе или политике
    Зарплата в Европе: от €40,000 до €75,000 в год
    Почему выбирают нас?
    • Европейский диплом, открывающий путь в науку и практику
    • Гибкая форма обучения: дистанционно или очно
    • Обучение на русском или английском языке
    • Современные методы анализа и цифровые платформы
    • Преподаватели — действующие социологи и аналитики
    • Поддержка приемной комиссии и помощь с научными стажировками
    Социология — это навигатор в сложном обществе. Мы учим читать карту.

    Как поступить?
    Приёмная комиссия поможет вам выбрать программу, подготовить документы и успешно пройти весь процесс поступления.
  `,
};
